// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__hC3XD","empty":"ModalGraph_empty__1rjn7"};